var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container py-5 bg-img" }, [
    _c(
      "h2",
      { staticClass: "text-center", staticStyle: { color: "#fdfaa4" } },
      [_vm._v("จำนวนสิทธิคงเหลือ " + _vm._s(_vm.count) + " ครั้ง")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex justify-content-center" },
      [
        _c("fortune-wheel", {
          ref: "wheel",
          attrs: {
            verify: _vm.canvasVerify,
            canvas: _vm.canvasOptionsMk,
            prizes: _vm.prizesMk,
            duration: 10000,
            timingFun: "cubic-bezier(0,.86,.39,.99)"
          },
          on: { rotateEnd: _vm.onRotateEnd, buttonClick: _vm.btnClicked }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "popup__modal", attrs: { id: "popupModal" } }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-success my-1 buttom__close__popup",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.closeModalPopUp()
            }
          }
        },
        [_vm._v("เปิดอั่งเปา")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "popup__modal", attrs: { id: "rewardModal" } }, [
      _c("div", { staticClass: "reward__modal__content" }, [
        _vm.receivedReward == "100 coins"
          ? _c("img", {
              staticClass: "img-fluid modal__img__content fade-in",
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_100c.png"
              }
            })
          : _vm.receivedReward == "50 coins"
          ? _c("img", {
              staticClass: "img-fluid modal__img__content fade-in",
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_50c.png"
              }
            })
          : _vm.receivedReward == "20 points"
          ? _c("img", {
              staticClass: "img-fluid modal__img__content fade-in",
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_20p.png"
              }
            })
          : _vm.receivedReward == "10 points"
          ? _c("img", {
              staticClass: "img-fluid modal__img__content fade-in",
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_10p.png"
              }
            })
          : _vm.receivedReward == "10 coins"
          ? _c("img", {
              staticClass: "img-fluid modal__img__content fade-in",
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_10c.png"
              }
            })
          : _vm.receivedReward == "2 hours"
          ? _c("img", {
              staticClass: "img-fluid modal__img__content fade-in",
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_2h.png"
              }
            })
          : _c("img", {
              staticClass: "img-fluid modal__img__content fade-in",
              attrs: {
                src:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_5p.png"
              }
            }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-fluid modal__img__bottom",
          attrs: {
            src:
              "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/reward_box.png"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-success my-1 buttom__close",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.closeModalReward()
            }
          }
        },
        [_vm._v("ปิด")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup__modal__content" }, [
      _c("img", {
        staticClass: "img-fluid rounded",
        attrs: {
          src:
            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/luckyRoulete/main_pop_up.jpg"
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87536120", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87536120","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/luckyRoulette/Index.vue
// module id = 2412
// module chunks = 0